import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";

/**
 * This is a `smart` component. It will remember which *Impression components have
 * been rendered to the screen and seen by the user.
 *
 * *
 * Dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { impressionReported as _impressionReported } from '../actions';
export default (function (ImpressionComponent) {
  var ImpressionState = /*#__PURE__*/function (_Component) {
    _inherits(ImpressionState, _Component);

    var _super = _createSuper(ImpressionState);

    function ImpressionState() {
      _classCallCheck(this, ImpressionState);

      return _super.apply(this, arguments);
    }

    _createClass(ImpressionState, [{
      key: "componentWillMount",
      value: // eslint-disable-next-line react/no-deprecated
      function componentWillMount() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (!this.props.impressions && process.env.NODE_ENV === 'development') {
          console.error('`impressions` reducer not found. Make sure to' + 'import the reducer and add to your redux store');
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(ImpressionComponent, this.props);
      }
    }]);

    return ImpressionState;
  }(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  ImpressionState.displayName = 'ImpressionState'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  ImpressionState.propTypes = {
    id: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    impressions: PropTypes.object,
    impressionReported: PropTypes.func.isRequired,
    hasBeenTracked: PropTypes.bool.isRequired
  };
  return connect(function (state, ownProps) {
    return {
      hasBeenTracked: !!state.impressions[ownProps.id],
      impressions: state.impressions
    };
  }, function (dispatch, ownProps) {
    return {
      impressionReported: function impressionReported(eventData) {
        return dispatch(_impressionReported(ownProps.id, eventData));
      }
    };
  })(ImpressionState);
});